var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74316 2.07127C10.1632 0.651182 12.4657 0.651183 13.8857 2.07127C15.3058 3.49136 15.3058 5.79378 13.8858 7.21386L7.71463 13.385C6.29455 14.8051 3.99213 14.8051 2.57204 13.385C1.15195 11.9649 1.15195 9.66247 2.57204 8.24239L8.74316 2.07127Z",
    fill: "#03543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00028 4.8997L10.5431 3.35692M5.6576 5.15683L10.8002 10.2994M2.57204 13.385V13.385C3.99213 14.8051 6.29455 14.8051 7.71463 13.385L13.8858 7.21386C15.3058 5.79378 15.3058 3.49136 13.8857 2.07127V2.07127C12.4657 0.651183 10.1632 0.651182 8.74316 2.07127L2.57204 8.24239C1.15195 9.66247 1.15195 11.9649 2.57204 13.385Z",
    stroke: "#DEF7EC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.ef0466ab8d7b044ca16439a0dae0a190.svg";
export { ForwardRef as ReactComponent };